module.exports = "/static-assets/_next/static/images/Liminals-890473dc179c5ce5ed7c8795e46d8e5f.png";